import { Component } from '@angular/core';
import { NxHeadlineModule } from '@allianz/ng-aquila/headline';
import { NxCopytextModule } from '@allianz/ng-aquila/copytext';
import { NxIconModule } from '@allianz/ng-aquila/icon';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-not-found',
  imports: [
    NxHeadlineModule,
    NxCopytextModule,
    NxIconModule,
    TranslocoPipe,
  ],
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.scss'
})
export class NotFoundComponent {

}
